// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lhsz","newExpiryDate":"styles_newExpiryDate__1kMeY","footer":"styles_footer__1tNhL"};